// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import date from '/util/date.js';
import {guess} from 'zuser_agent';

interface i_data_url_options {
    from: string;
    to: string;
    text: string;
}
const get_data_url = ({from, to, text}:i_data_url_options)=>{
    const ics_begin = ['BEGIN:VCALENDAR', 'VERSION:2.0',
        'PRODID:-//https://hola.org//Reminder v1.0//EN', 'BEGIN:VEVENT'];
    const ics_mid = [
        `UID:${from}-${to}`,
        `DTSTAMP:${from}`,
        `DTSTART:${from}`,
        `DTEND:${to}`,
        `SUMMARY:${text}`
    ];
    const ics_end = ['END:VEVENT', 'END:VCALENDAR'];
    const ics_content = [...ics_begin, ...ics_mid, ...ics_end];
    return 'data:text/calendar;charset=utf-8,' +
        encodeURIComponent(ics_content.join('\r\n'));
};

const get_cal_date_str = (d: Date):string=>date.strftime('%Y%m%dT%H%M%S', d);

interface i_cal_options {
    start: Date;
    end?: Date;
    type?: string;
    text?: string;
}
const get_cal_url = (opt:i_cal_options)=>{
    const {start, end, type='google', text='reminder'} = opt;
    const from = get_cal_date_str(start);
    const to = get_cal_date_str(end || date.add(start, {day: 1}));
    if (type == 'apple')
        return get_data_url({from, to, text});
    return 'https://calendar.google.com/calendar/u/0/r/eventedit?dates='+
        `${from}/${to}&text=${text}`;
};

interface i_cal_link_props extends i_cal_options {
    title: JSX.Element | string;
}
export const Cal_link = (props:i_cal_link_props)=>{
    const {title, ...rest} = props;
    const {type} = rest;
    const sys = guess();
    const a_props = {
        target: sys.mobile ? '_self' : '_blank',
        rel: 'noopener',
        download: type=='apple' ? 'reminder.ics' : null,
    };
    return <a href={get_cal_url(rest)} {...a_props}>{title}</a>;
};
